import React from "react";

import Greycroft from "../../../../../public/greycroft.svg";
import Alleycorp from "../../../../../public/alleycorp.svg";
import Sound from "../../../../../public/sound.svg";
import Thrive from "../../../../../public/thrive-capital.svg";
import Harlem from "../../../../../public/harlem-capital.png";

export const investors = [
  Greycroft,
  Alleycorp,
  Sound,
  Thrive,
  ({ className }: { className: string }) => (
    <img src={Harlem.src} alt="" className={className} />
  )
];
